import { render, staticRenderFns } from "./Pro.vue?vue&type=template&id=640ecc9e&scoped=true&"
import script from "./Pro.vue?vue&type=script&lang=ts&"
export * from "./Pro.vue?vue&type=script&lang=ts&"
import style0 from "./Pro.vue?vue&type=style&index=0&id=640ecc9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640ecc9e",
  null
  
)

export default component.exports